import { cn } from "@/lib/utils";

/**
 * Belgi — "Q". `public/logo.svg` bilan bir xil shakl, lekin inline SVG:
 * rang `currentColor` dan olinadi va qorong'i rejimda o'zi moslashadi.
 *
 * Bu — brendning qisqa shakli: brauzer yorlig'i va yuklovchilar shu
 * belgini ko'rsatadi.
 */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="30 30 205.48 205.48"
      className={cn("size-8", className)}
      role="img"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="128" cy="128" r="87" fill="none" stroke="currentColor" strokeWidth="22" />
      <path
        d="M 210.74 154.88 L 235.48 212.85 L 212.85 235.48 L 151.98 211.63 Z"
        fill="currentColor"
      />
      <circle cx="128" cy="128" r="46" fill="currentColor" />
    </svg>
  );
}

/**
 * To'liq logotip: "Q" belgisi va "ahvadosh" yozuvi bitta SVG da —
 * `public/wordmark.svg` bilan bir xil shakl. Yozuv matn emas, kontur:
 * shrift yuklanishini kutmaydi va rang `currentColor` dan keladi.
 */
export function LogoWordmark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 6425.71 1307.6"
      className={cn("h-5 w-auto", className)}
      role="img"
      aria-label="Qahvadosh"
      focusable="false"
    >
      <g transform="translate(0,1004.30) scale(1,-1)">
        <g transform="translate(-190.91,1195.21) scale(6.36364,-6.36364)">
          <circle
            cx="128.0"
            cy="128.0"
            r="87.0"
            fill="none"
            stroke="currentColor"
            strokeWidth="22.0"
          />
          <path
            d="M 210.74 154.88 L 235.48 212.85 L 212.85 235.48 L 151.98 211.63 Z"
            fill="currentColor"
          />
          <circle cx="128.0" cy="128.0" r="46.0" fill="currentColor" />
        </g>
        <g fill="currentColor" transform="translate(1351.71,0)">
          <path
            d="M286 563Q348 563 394.5 538.0Q441 513 469 475V554H610V0H469V81Q442 42 394.5 16.5Q347 -9 285 -9Q215 -9 157.5 27.0Q100 63 66.5 128.5Q33 194 33 279Q33 363 66.5 428.0Q100 493 157.5 528.0Q215 563 286 563ZM322 440Q283 440 250.0 421.0Q217 402 196.5 365.5Q176 329 176 279Q176 229 196.5 191.5Q217 154 250.5 134.0Q284 114 322 114Q361 114 395.0 133.5Q429 153 449.0 189.5Q469 226 469 277Q469 328 449.0 364.5Q429 401 395.0 420.5Q361 440 322 440Z"
            transform="translate(0.0,0.0)"
          />
          <path
            d="M597 325V0H457V306Q457 372 424.0 407.5Q391 443 334 443Q276 443 242.5 407.5Q209 372 209 306V0H69V740H209V485Q236 521 281.0 541.5Q326 562 381 562Q444 562 493.0 534.5Q542 507 569.5 453.5Q597 400 597 325Z"
            transform="translate(678.0,0.0)"
          />
          <path d="M300 129 440 554H589L384 0H214L10 554H160Z" transform="translate(1339.0,0.0)" />
          <path
            d="M286 563Q348 563 394.5 538.0Q441 513 469 475V554H610V0H469V81Q442 42 394.5 16.5Q347 -9 285 -9Q215 -9 157.5 27.0Q100 63 66.5 128.5Q33 194 33 279Q33 363 66.5 428.0Q100 493 157.5 528.0Q215 563 286 563ZM322 440Q283 440 250.0 421.0Q217 402 196.5 365.5Q176 329 176 279Q176 229 196.5 191.5Q217 154 250.5 134.0Q284 114 322 114Q361 114 395.0 133.5Q429 153 449.0 189.5Q469 226 469 277Q469 328 449.0 364.5Q429 401 395.0 420.5Q361 440 322 440Z"
            transform="translate(1938.0,0.0)"
          />
          <path
            d="M287 563Q341 563 390.0 539.5Q439 516 468 477V740H610V0H468V82Q442 41 395.0 16.0Q348 -9 286 -9Q216 -9 158.0 27.0Q100 63 66.5 128.5Q33 194 33 279Q33 363 66.5 428.0Q100 493 158.0 528.0Q216 563 287 563ZM322 440Q283 440 250.0 421.0Q217 402 196.5 365.5Q176 329 176 279Q176 229 196.5 191.5Q217 154 250.5 134.0Q284 114 322 114Q361 114 395.0 133.5Q429 153 449.0 189.5Q469 226 469 277Q469 328 449.0 364.5Q429 401 395.0 420.5Q361 440 322 440Z"
            transform="translate(2616.0,0.0)"
          />
          <path
            d="M34 277Q34 362 71.5 427.0Q109 492 174.0 527.5Q239 563 319 563Q399 563 464.0 527.5Q529 492 566.5 427.0Q604 362 604 277Q604 192 565.5 127.0Q527 62 461.5 26.5Q396 -9 315 -9Q235 -9 171.0 26.5Q107 62 70.5 127.0Q34 192 34 277ZM460 277Q460 356 418.5 398.5Q377 441 317 441Q257 441 216.5 398.5Q176 356 176 277Q176 198 215.5 155.5Q255 113 315 113Q353 113 386.5 131.5Q420 150 440.0 187.0Q460 224 460 277Z"
            transform="translate(3294.0,0.0)"
          />
          <path
            d="M39 175H180Q184 143 211.5 122.0Q239 101 280 101Q320 101 342.5 117.0Q365 133 365 158Q365 185 337.5 198.5Q310 212 250 228Q188 243 148.5 259.0Q109 275 80.5 308.0Q52 341 52 397Q52 443 78.5 481.0Q105 519 154.5 541.0Q204 563 271 563Q370 563 429.0 513.5Q488 464 494 380H360Q357 413 332.5 432.5Q308 452 267 452Q229 452 208.5 438.0Q188 424 188 399Q188 371 216.0 356.5Q244 342 303 327Q363 312 402.0 296.0Q441 280 469.5 246.5Q498 213 499 158Q499 110 472.5 72.0Q446 34 396.5 12.5Q347 -9 281 -9Q213 -9 159.0 15.5Q105 40 73.5 82.0Q42 124 39 175Z"
            transform="translate(3932.0,0.0)"
          />
          <path
            d="M597 325V0H457V306Q457 372 424.0 407.5Q391 443 334 443Q276 443 242.5 407.5Q209 372 209 306V0H69V740H209V485Q236 521 281.0 541.5Q326 562 381 562Q444 562 493.0 534.5Q542 507 569.5 453.5Q597 400 597 325Z"
            transform="translate(4477.0,0.0)"
          />
        </g>
      </g>
    </svg>
  );
}

/**
 * Yon panel logotipi. Yig'ilgan holatda faqat "Q" belgisi qoladi.
 */
export function Logo({
  collapsed = false,
  tone = "sidebar",
}: {
  collapsed?: boolean;
  /**
   * `sidebar` — espresso yon panel ustida (och rang), `page` — oddiy
   * sahifa fonida (kirish talab qilinadigan ekran). Yon panel to'q
   * bo'lgach, bitta rang ikkala joyda ham o'qilmay qoldi.
   */
  tone?: "sidebar" | "page";
}) {
  const color = tone === "sidebar" ? "text-sidebar-foreground" : "text-primary";

  // Yon panel endi espresso fonda: `text-primary` (o'sha espresso) bu
  // yerda ko'rinmay qolardi, shuning uchun rang panel tokenidan olinadi.
  if (collapsed) {
    return <LogoMark className={cn(color, "size-7 shrink-0")} />;
  }

  return (
    <span className="inline-flex items-center gap-2 overflow-hidden">
      <LogoWordmark className={cn(color, "h-5 w-auto shrink-0")} />
      <span className="bg-sidebar-primary text-sidebar-primary-foreground truncate rounded-full px-2 py-0.5 text-[11px] font-semibold tracking-wide uppercase">
        Admin
      </span>
    </span>
  );
}
